import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";

export default function AboutPage() {
  return (
    <div style={{ fontFamily: "'Inter', -apple-system, sans-serif", background: "#fff", minHeight: "100vh" }}>
      <Helmet>
        <title>About Hub360 - B2B Wholesale E-Commerce Platform by Skyhubs</title>
        <meta name="description" content="Hub360 is a modern B2B wholesale e-commerce platform built by Skyhubs Technolabs. Seamlessly integrates with Saral Accounting to streamline business operations." />
        <link rel="canonical" href="https://ecom.skyhubs.in/about" />
        <meta property="og:title" content="About Hub360 - B2B Wholesale E-Commerce Platform" />
        <meta property="og:description" content="Learn about Hub360, the modern B2B wholesale e-commerce platform with Saral Accounting integration." />
        <meta property="og:url" content="https://ecom.skyhubs.in/about" />
        <script type="application/ld+json">{`
          {
            "@context": "https://schema.org",
            "@type": "AboutPage",
            "name": "About Hub360",
            "url": "https://ecom.skyhubs.in/about",
            "mainEntity": {
              "@type": "Organization",
              "name": "Hub360 by Skyhubs Technolabs",
              "url": "https://skyhubs.in",
              "description": "Modern B2B wholesale e-commerce platform"
            }
          }
        `}</script>
      </Helmet>

      {/* Header */}
      <div style={{ borderBottom: "1px solid #f1f5f9", padding: "16px 0" }}>
        <div style={{ maxWidth: "1100px", margin: "0 auto", padding: "0 24px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <Link to="/" style={{ textDecoration: "none", display: "flex", alignItems: "center", gap: "8px" }}>
            <div style={{ width: "28px", height: "28px", background: "#4f46e5", borderRadius: "6px", display: "flex", alignItems: "center", justifyContent: "center" }}>
              <span style={{ fontSize: "13px", fontWeight: "900", color: "#fff" }}>H</span>
            </div>
            <span style={{ fontSize: "20px", fontWeight: "800", color: "#0f172a" }}>Hub<span style={{ color: "#4f46e5" }}>360</span></span>
          </Link>
          <Link to="/" style={{ fontSize: "14px", color: "#4f46e5", textDecoration: "none", fontWeight: "600" }}>
            &larr; Back to Home
          </Link>
        </div>
      </div>

      <div style={{ maxWidth: "720px", margin: "0 auto", padding: "48px 24px 80px" }}>
        <h1 style={{ fontSize: "32px", fontWeight: "800", color: "#0f172a", marginBottom: "16px", letterSpacing: "-0.5px" }}>
          About Hub360
        </h1>
        <p style={{ fontSize: "17px", color: "#64748b", lineHeight: 1.7, marginBottom: "32px" }}>
          Hub360 is a modern B2B wholesale e-commerce platform designed to help businesses digitize their
          wholesale operations and grow faster.
        </p>

        <h2 style={{ fontSize: "22px", fontWeight: "700", color: "#0f172a", marginBottom: "12px" }}>Our Mission</h2>
        <p style={{ fontSize: "15px", color: "#475569", lineHeight: 1.7, marginBottom: "28px" }}>
          We believe every wholesale business deserves access to modern technology. Hub360 bridges the gap
          between traditional wholesale operations and digital commerce, making it simple for businesses
          to manage orders, inventory, and finances in one place.
        </p>

        <h2 style={{ fontSize: "22px", fontWeight: "700", color: "#0f172a", marginBottom: "12px" }}>Saral Accounting Integration</h2>
        <p style={{ fontSize: "15px", color: "#475569", lineHeight: 1.7, marginBottom: "28px" }}>
          Hub360 seamlessly integrates with Saral Accounting software, eliminating manual data entry and
          ensuring your financial records are always accurate. Orders placed on Hub360 automatically sync
          with your Saral Accounting system in real-time.
        </p>

        <h2 style={{ fontSize: "22px", fontWeight: "700", color: "#0f172a", marginBottom: "12px" }}>Built by Skyhubs Technolabs</h2>
        <p style={{ fontSize: "15px", color: "#475569", lineHeight: 1.7, marginBottom: "28px" }}>
          Hub360 is developed and maintained by <a href="https://skyhubs.in" style={{ color: "#4f46e5", textDecoration: "none", fontWeight: "600" }}>Skyhubs Technolabs</a>,
          a technology company focused on building practical software solutions for Indian businesses.
        </p>

        <h2 style={{ fontSize: "22px", fontWeight: "700", color: "#0f172a", marginBottom: "12px" }}>Contact Us</h2>
        <p style={{ fontSize: "15px", color: "#475569", lineHeight: 1.7 }}>
          Phone: <a href="tel:+919904554232" style={{ color: "#4f46e5", textDecoration: "none" }}>+91 99045 54232</a><br />
          Email: <a href="mailto:info@skyhubs.in" style={{ color: "#4f46e5", textDecoration: "none" }}>info@skyhubs.in</a>
        </p>
      </div>
    </div>
  );
}
